import{a as e}from"./chunk-I7VC7S6W.js";import{m as o,n as r}from"./chunk-ETMID2O5.js";var f=new o({locale:[e,r]});export{f as a};
